<template>
  <div>
    <span>{{ countDownTime.hh }}:</span>
    <span>{{ countDownTime.mm }}:</span>
    <span>{{ countDownTime.ss }}</span>
  </div>
</template>

<script>
export default {
  props: {
    endTime: {
      type: Number,
      required: true
    },
  },
  data() {
    return {
      countDownTime: {
        hh: '00',
        mm: '00',
        ss: '00',
      },
      timerId: null,
    };
  },
  mounted() {
    this.startCountDown(this.endTime);
  },
  watch: {
    endTime(newEndTime) {
      this.resetTimer();
      this.startCountDown(newEndTime);
    }
  },
  beforeDestroy() {
    this.clearTimer();
  },
  methods: {
    startCountDown(endTime) {
      this.timerId = setInterval(() => {
        const t = Math.floor((endTime - Date.now()) / 1000);
        if (t >= 0) {
          const hh = Math.floor(t / 3600);
          const mm = Math.floor((t % 3600) / 60);
          const ss = t % 60;
          this.countDownTime = {
            hh: String(hh).padStart(2, '0'),
            mm: String(mm).padStart(2, '0'),
            ss: String(ss).padStart(2, '0'),
          };
        } else {
          if (t === 0) {
            this.clearTimer();
          }
        }
      }, 500);
    },
    clearTimer() {
      if (this.timerId) {
        clearInterval(this.timerId);
        this.timerId = null;
      }
    },
    resetTimer() {
      this.clearTimer();
    }
  }
};
</script>
